var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('td',{attrs:{"slot":"button"},slot:"button"},[_c('kendo-dropdownlist',{staticClass:"dropdown-unstyled",attrs:{"data-source":_vm.items,"valueTemplate":_vm.actionValueTemplate,"template":_vm.actionTemplate,"select":_vm.onSelect,"auto-width":true,"popup":{position: 'top right', origin: 'bottom right'}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }